"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReducer = createReducer;
exports.farmSearch = void 0;

var _redux = require("redux");

var _lodash = _interopRequireDefault(require("lodash"));

var _reducers = require("../../components/search/reducers");

var _reducer = require("../../components/hofsearch-map/reducer");

var _sfpReactCookieBanner = require("sfp-react-cookie-banner");

var _iframe = require("./iframe");

var _extSearch = require("./extSearch");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createReducer(initState, handlers) {
  return function reducer(state, action) {
    if (!state) return initState;

    if (handlers.hasOwnProperty(action.type)) {
      /*eslint-disable-line no-prototype-builtins*/
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  };
}

var globalReducer = {}; //Update search filters

globalReducer['update-search-filters'] = function (state, action) {
  function customizer(objValue, srcValue) {
    if (_lodash.default.isArray(objValue)) {
      return srcValue;
    }
  }

  return _lodash.default.mergeWith({}, state, {
    filters: {
      cantons: action.data.cantons,
      projects: action.data.projects,
      productionTypes: action.data.productionTypes,
      productionLabels: action.data.productionLabels,
      soldout: action.data.soldout,
      lgwProducts: action.data.lgwProducts,
      lgwDeliveryType: action.data.lgwDeliveryType
    }
  }, customizer);
};

var shared = createReducer({
  filters: {
    cantons: [],
    projects: [],
    productionTypes: [],
    productionLabels: [],
    lgwProducts: [],
    lgwDeliveryType: [],
    soldout: []
  }
}, globalReducer);
var iframe = createReducer((0, _iframe.getIframeSettingsFromLocation)(), {});
var extSearch = createReducer((0, _extSearch.getExtSearchSettingsFromLocation)(), {});
var farmSearch = (0, _redux.combineReducers)({
  shared: shared,
  farm: _reducers.farm,
  iframe: iframe,
  extSearch: extSearch,
  map: _reducer.map,
  consentStates: _sfpReactCookieBanner.consentStates
});
exports.farmSearch = farmSearch;


//////////////////
// WEBPACK FOOTER
// ./client/lib/reducer/index.js
// module id = 178
// module chunks = 0